import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './services-rail-container.css'

const ServicesRailContainer = (props) => {
  return (
    <div
      id={props.servicesRailContainerId}
      className="services-rail-container-thq-services-rail-container-elm services-rail-container"
    >
      <div className="services-rail">
        <div className="service-card">
          <div className="service-icon-box">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 6v6l4 2"></path>
                <circle r="10" cx="12" cy="12"></circle>
              </g>
            </svg>
          </div>
          <h3 className="service-card-title services-rail-container-thq-service-card-title-elm1">
            {props.serviceCardTitle ?? (
              <Fragment>
                <span className="services-rail-container-text11">
                  <span>Rush</span>
                  <br></br>
                  <span> Service</span>
                </span>
              </Fragment>
            )}
          </h3>
          <p className="section-content">
            {props.sectionContent ?? (
              <Fragment>
                <span className="services-rail-container-text10">
                  Immediate dispatch for time-sensitive legal documents across
                  the DFW Metroplex.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="service-card">
          <div className="service-icon-box">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle r="3" cx="12" cy="10"></circle>
              </g>
            </svg>
          </div>
          <h3 className="service-card-title">
            {props.serviceCardTitle1 ?? (
              <Fragment>
                <span className="services-rail-container-text20">
                  DFW Metroplex Coverage
                </span>
              </Fragment>
            )}
          </h3>
          <p className="section-content">
            {props.sectionContent1 ?? (
              <Fragment>
                <span className="services-rail-container-text19">
                  Expert process service covering every corner of the
                  Dallas–Fort Worth area.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="service-card">
          <div className="service-icon-box">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
          <h3 className="service-card-title">
            {props.serviceCardTitle3 ?? (
              <Fragment>
                <span className="services-rail-container-text17">
                  Nationwide Network
                </span>
              </Fragment>
            )}
          </h3>
          <p className="section-content">
            {props.sectionContent3 ?? (
              <Fragment>
                <span className="services-rail-container-text18">
                  Coordinated service across the United States via a
                  professional network of certified servers.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <div className="service-card">
          <div className="service-icon-box">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M21 5H3m12 7H3m14 7H3"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </div>
          <h3 className="service-card-title">
            {props.serviceCardTitle4 ?? (
              <Fragment>
                <span className="services-rail-container-text15">
                  Mobile Notary Services
                </span>
              </Fragment>
            )}
          </h3>
          <p className="section-content">
            {props.sectionContent4 ?? (
              <Fragment>
                <span className="services-rail-container-text16">
                  Convenient mobile notary services for all notary needs.
                </span>
              </Fragment>
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

ServicesRailContainer.defaultProps = {
  sectionContent: undefined,
  serviceCardTitle: undefined,
  serviceCardTitle4: undefined,
  sectionContent4: undefined,
  serviceCardTitle3: undefined,
  sectionContent3: undefined,
  sectionContent1: undefined,
  servicesRailContainerId: '',
  serviceCardTitle1: undefined,
}

ServicesRailContainer.propTypes = {
  sectionContent: PropTypes.element,
  serviceCardTitle: PropTypes.element,
  serviceCardTitle4: PropTypes.element,
  sectionContent4: PropTypes.element,
  serviceCardTitle3: PropTypes.element,
  sectionContent3: PropTypes.element,
  sectionContent1: PropTypes.element,
  servicesRailContainerId: PropTypes.string,
  serviceCardTitle1: PropTypes.element,
}

export default ServicesRailContainer
